/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SourceAccountConfiguration {
  /**
  * Whether CDC backup is enabled
  */
  'enableCdcBackup': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "enableCdcBackup",
      "baseName": "enableCdcBackup",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SourceAccountConfiguration.attributeTypeMap;
  }

  public constructor() {
  }
}

